// import { Grid } from "@mui/material";
// import { allCountries } from "country-telephone-data";
// import { format } from "date-fns";
// import React, { useEffect, useState } from "react";
// import Datetime from "react-datetime";
// import Autocomplete from "react-google-autocomplete";
// import { useDispatch, useSelector } from "react-redux";
// import { toast } from "react-toastify";
// import api from "../../../../../api/api";
// import {
//   calender_image,
//   email_image,
//   gender_image,
//   grade_image,
//   language_image,
//   location_image,
//   profile_image,
//   upload_image,
//   devicon_linkedin,
// } from "../../../../../assets/images/images";
// import EditSubject from "../../../../../components/EditSubject.js/EditSubject";
// import { GOOGLE_MAP_KEY } from "../../../../../consts/constants";
// import { useAuth } from "../../../../../features/auth/AuthContext";
// import { updateGlobalState } from "../../../../../state/global/slice";
// import { compressImage } from "../../../../../utils/CompressImage";
// import { genders, titles } from "../../../../../utils/consts";
// import { getIdsForLanguages, getKeyByValue } from "../../../../../utils/utlis";
// import {
//   isMaxChar,
//   isRequired,
//   isValidLinkedinUrl,
//   isValidMobileNumber,
//   isValidName,
// } from "../../../../../utils/validator";
// import CropProfileImageModal from "../../dashboard/CropProfileImageModal";
// // import { google_drive_logo, connection_icon, sync_icon, notConnectedIcon } from "../../../../../assets/images/images";
// import {
//   submitGoogleToken,
//   resetsubmitgoogleToken,
// } from "../../../../../state/actions/submitGoogleTokenAction";
// import {
//   getGoogleTokenAction,
//   resetGoogleToken,
// } from "../../../../../state/actions/getGoogleTokenAction";
// import {
//   unlinkGDrive,
//   resetunlinkGoogleDrive,
// } from "../../../../../state/actions/unlinkGoogleDriveAction";
// import {
//   linkGDrive,
//   resetlinkGoogleDrive,
// } from "../../../../../state/actions/linkGoogleDriveAction";
// import { useGoogleLogin } from "@react-oauth/google";
// import PrimaryBtn from "../../../../../components/Buttons/PrimaryBtn";
// import CustomModal from "../../../../../components/CustomModal/CustomModal";
// import Header from "../../../../../components/FileRepo/Components/Header";
// import DataTable, {
//   DeleteAction,
//   DownloadAction,
//   EditAction,
//   FavouriteAction,
//   MoveAction,
//   RowActionsTray,
// } from "../../../../../components/FileRepo/Components/DataTable";
// import { fileIcons } from "../../../../../components/FileRepo/Icons";
// import { formatFileSize } from "../../../../../components/FileRepo/utils/utils";
// import { getFileActions } from "../../../../../components/FileRepo/utils/fileActions";
// import ProfileModal from "../../../../../components/FileRepo/FileActions/ProfileModal";
// import UploadFileBtn from "../../../../../components/FileRepo/Components/Buttons/UploadFileBtn";
// import dayjs from "dayjs";
// import TeacherProfileView, { getTeacherLinks } from "./TeacherProfileView";

// function Profile() {
//   const { token } = useAuth();
//   const globalState = useSelector((state) => state.globalState);
//   const isTeacher = globalState.role === "Teacher";

//   const updateState = (key, value) => {
//     dispatch(updateGlobalState({ key: key, value: value }));
//   };
//   const dispatch = useDispatch();
//   const [selectedFile, setSelectedFile] = useState(null);

//   const today = new Date().toISOString().split("T")[0];
//   const [isEditable, setIsEditable] = useState(false);
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [imageUploaded, setImageUploaded] = useState(false);
//   const [uplodedImage, setUplodedImage] = useState({});
//   const [uploadFileModal, setUploadFileModal] = useState(false);
//   const getFormattedDate = (isoDate) => {
//     const dateObj = new Date(isoDate);
//     const options = { year: "numeric", month: "short", day: "numeric" };
//     return dateObj.toLocaleDateString("en-US", options); // Converts to a format like "Oct 18, 2023"
//   };
//   const ai_avatar = isTeacher
//     ? globalState.teacher_details?.data?.ai_avatar
//     : globalState.student_details?.data?.student_profile_pic;
//   const [AddtoLanguages, setAddtoLanguages] = useState(
//     globalState.datalist?.languages ? globalState.datalist?.languages : [],
//   );
//   useEffect(() => {
//     // api
//     //   .get("/auth/get-datalist/")
//     //   .then((response) => {
//     //     setAddtoLanguages(response.data.languages);
//     //     updateState("datalist", response?.data ?? {});
//     //   })
//     //   .catch((error) => {
//     //   });
//   }, []);
//   const [gradedetails, setGradedetails] = useState([]);
//   const subjectsKey = isTeacher ? "subject_names" : "interest_names";

//   const [formState, setFormState] = useState({
//     name: isTeacher
//       ? globalState.teacher_details?.data?.name
//       : globalState.student_details?.data?.name,
//     title: isTeacher
//       ? Object.keys(globalState.teacher_details?.data?.title)[0]
//       : globalState.student_details?.data?.title,
//     grade: isTeacher
//       ? null
//       : Object.keys(globalState.student_details?.data?.grade)[0],
//     introduction: isTeacher
//       ? globalState.teacher_details?.data?.introduction
//       : globalState.student_details?.data?.introduction,
//     email: isTeacher
//       ? globalState.teacher_details?.data?.email
//       : globalState.student_details?.data?.email,
//     [subjectsKey]: isTeacher
//       ? Object.values(globalState.teacher_details?.data?.subjects || {})
//       : Object.values(globalState.student_details?.data?.interest || {}),
//     dob: isTeacher
//       ? globalState.teacher_details?.data?.dob
//       : globalState.student_details?.data?.dob,
//     gender: Object.keys(
//       isTeacher
//         ? globalState.teacher_details?.data?.gender
//         : globalState.student_details?.data?.gender,
//     )[0],
//     language_ids:
//       isTeacher && Object.values(AddtoLanguages)
//         ? getIdsForLanguages(
//             Object.values(globalState.teacher_details?.data?.language),
//             AddtoLanguages,
//           )
//         : null,
//     language: !isTeacher
//       ? Object.values(globalState.student_details?.data?.language)?.join(",")
//       : null,
//     location: isTeacher
//       ? globalState.teacher_details?.data?.location
//       : globalState.student_details?.data?.location,
//     linkedin_url: isTeacher
//       ? globalState.teacher_details?.data?.linkedin_url
//       : null,
//     university: isTeacher ? globalState.teacher_details?.data?.university ?? "" : null,
//     experience: isTeacher ? globalState.teacher_details?.data?.experience ?? "" : null,
//   });
//   // Teacher inline-edit state (links, certificates waiting for upload, save in progress)
//   const [editLinks, setEditLinks] = useState([]);
//   const [pendingCertificates, setPendingCertificates] = useState([]);
//   const [isSaving, setIsSaving] = useState(false);
//   const [formErrors, setFormErrors] = useState({
//     name: "",
//     grade: "",
//     introduction: "",
//     lastname: "",
//     email: "",
//     dob: "",
//     gender: "",
//     location: "",
//     language: "",
//     title: "",
//   });

//   const [selectedCountry, setSelectedCountry] = useState({
//     name: "United States",
//     iso2: "us",
//     dialCode:
//       globalState.teacher_details?.data?.country_code &&
//       globalState.teacher_details?.data?.country_code.replace(/\+/g, ""),
//     format: "+...-...-....",
//     hasAreaCodes: false,
//   });

// const [dobInputValue, setDobInputValue] = useState(() => {
//   if (!formState.dob) return "";
//   const parsed = dayjs(formState.dob);
//   return parsed.isValid() ? parsed.format("MM/DD/YYYY") : "";
// });

// const handleDobInput = (e) => {
//   const raw = e.target.value;

//   if (raw.length < dobInputValue.length) {
//     setDobInputValue(raw);
//     if (raw.length < 10) setFormState((prev) => ({ ...prev, dob: "" }));
//     return;
//   }

//   let digits = raw.replace(/\D/g, "");
//   let value = digits;
//   if (digits.length >= 3 && digits.length <= 4) {
//     value = digits.slice(0, 2) + "/" + digits.slice(2);
//   } else if (digits.length >= 5) {
//     value = digits.slice(0, 2) + "/" + digits.slice(2, 4) + "/" + digits.slice(4, 8);
//   }

//   setDobInputValue(value);

//   if (value.length === 10) {
//     const parsed = dayjs(value, "MM/DD/YYYY", true);
//     if (!parsed.isValid()) {
//       setFormErrors((prev) => ({ ...prev, dob: "Please enter a valid date (MM/DD/YYYY)" }));
//       setFormState((prev) => ({ ...prev, dob: "" }));
//       return;
//     }
//     const today = new Date();
//     const selectedDate = parsed.toDate();
//     const minDate = new Date();
//     minDate.setFullYear(today.getFullYear() - (isTeacher ? 21 : 4));

//     if (selectedDate > today) {
//       setFormErrors((prev) => ({ ...prev, dob: "Date of birth cannot be in the future" }));
//       setFormState((prev) => ({ ...prev, dob: "" }));
//       return;
//     }
//     if (selectedDate > minDate) {
//       setFormErrors((prev) => ({ ...prev, dob: isTeacher ? "Teacher must be at least 21 years old" : "Student must be at least 4 years old" }));
//       setFormState((prev) => ({ ...prev, dob: "" }));
//       return;
//     }
//     setFormState((prev) => ({ ...prev, dob: parsed.format("YYYY-MM-DD") }));
//     setFormErrors((prev) => ({ ...prev, dob: "" }));
//   } else {
//     setFormState((prev) => ({ ...prev, dob: "" }));
//     setFormErrors((prev) => ({ ...prev, dob: "" }));
//   }
// };

//   function isValidDateTeacher(val) {
//     let today = new Date();
//     let twentyOneYearsAgo = new Date();
//     twentyOneYearsAgo.setFullYear(today.getFullYear() - 21);
//     twentyOneYearsAgo.setHours(0, 0, 0, 0); // Set time to the start of the day

//     let selectedDate = new Date(val);
//     selectedDate.setHours(0, 0, 0, 0); // Set time to the start of the day

//     // Check if the selected date is after today or if it is less than 21 years ago
//     if (selectedDate > today || selectedDate > twentyOneYearsAgo) {
//       return false;
//     }
//     return true;
//   }

//   function isValidDateStudent(val) {
//     let today = new Date();
//     let twentyOneYearsAgo = new Date();
//     twentyOneYearsAgo.setFullYear(today.getFullYear() - 4);
//     twentyOneYearsAgo.setHours(0, 0, 0, 0); // Set time to the start of the day

//     let selectedDate = new Date(val);
//     selectedDate.setHours(0, 0, 0, 0); // Set time to the start of the day

//     // Check if the selected date is after today or if it is less than 21 years ago
//     if (selectedDate > today || selectedDate > twentyOneYearsAgo) {
//       return false;
//     }
//     return true;
//   }

//   const handleDateChanged = (value) => {
//     let error = "";
//     error = isRequired(value);
//     setFormErrors({
//       ...formErrors,
//       dob: error,
//     });
//     setFormState((prev) => ({
//       ...prev,
//       dob: format(new Date(value), "yyyy-MM-dd"),
//     }));
//   };

//   const handleInputChange = (event) => {
//     const { name, value } = event.target;

//     let error = "";

//     // Trim whitespace and validate
//     if (value.trim() === "") {
//       // Optional fields
//       if (!["linkedin_url", "university", "experience"].includes(name)) {
//         error = "• This field is required";
//       }
//     } else {
//       if (name === "name") {
//         error = isRequired(value) || isValidName(value);
//       } else if (name === "title") {
//         error = value === "" || value === "0" ? "Please select title" : "";
//       } else if (name === "introduction") {
//         error = isRequired(value) || isMaxChar(value);
//       } else if (name === "lastname") {
//         error = isRequired(value);
//       } else if (name === "grade") {
//         error = isRequired(value);
//       } else if (name === "email") {
//         error = isRequired(value);
//       } else if (name === "dob") {
//         error = isRequired(value);
//       } else if (name === "gender") {
//         error = value === "" || value === "0" ? "• Please select gender" : "";
//       } else if (name === "location") {
//         error = isRequired(value);
//       } else if (name === "language") {
//         error = isRequired(value);
//       } else if (name === "country_code") {
//         error = isValidMobileNumber(value, selectedCountry.dialCode);
//       } else if (name === "linkedin_url") {
//         error = isValidLinkedinUrl(value);
//       }
//     }

//     if (name === "linkedin_url" && value.trim() !== "") {
//       setFormErrors({
//         ...formErrors,
//         linkedin_url: "", // Clear error when a valid LinkedIn URL is entered
//       });
//     }

//     // Clear the error if the language field is filled
//     if (name === "language" && value.trim() !== "") {
//       setFormErrors({
//         ...formErrors,
//         language: "", // Clear error when a valid language is selected
//       });
//     }

//     setFormErrors({
//       ...formErrors,
//       [name]: error,
//     });

//     setFormState((prev) => ({ ...prev, [name]: value }));
//   };

//   const getUpdatedFields = () => {
//     const updatedFields = Object.entries(formState).reduce(
//       (result, [key, value]) => {
//         const teacherValue = globalState.teacher_details?.data[key];
//         const studentValue = globalState.student_details?.data[key];

//         // Check if the value is not null and different from teacherValue and studentValue
//         if (
//           value !== teacherValue &&
//           value !== studentValue &&
//           value !== null
//         ) {
//           result[key] = value;
//         }

//         return result;
//       },
//       {},
//     );

//     return updatedFields;
//   };
//   const handleForm4Submit = async (e) => {
//     await submitForm();
//   };
//   const submitForm = async () => {
//     toast.dismiss();
//     const updatedFormState = {
//       ...getUpdatedFields(),
//       [subjectsKey]: formState[subjectsKey]?.join(","),
//     };
//     if (isTeacher) {
//       try {
//         const response = await api.put(
//           `auth/update-teacher/?teacher_id=${globalState.teacher_details?.data?.teacher_id}`,
//           updatedFormState,
//           {
//             headers: {
//               "Content-Type": "multipart/form-data",
//               Authorization: `Token ${token}`,
//             },
//           },
//         );

//         if (response?.data?.status === 200) {
//           updateState("teacher_details", response?.data ?? {});
//           setIsEditable(false);

//           toast.success(
//             response?.data?.message ||
//               "Teacher profile has been updated successfully.",
//             {
//               position: "top-center",
//             },
//           );
//         } else {
//           setIsEditable(false);
//           toast.error(response?.data?.message || "Something went wrong!", {
//             position: "top-center",
//           });
//         }
//       } catch (error) {
//         setIsEditable(false);
//         toast.error(
//           error?.response?.data?.message ||
//             error?.response?.data?.error ||
//             "Something went wrong!",
//           {
//             position: "top-center",
//           },
//         );
//       }
//     } else {
//       const newFormState = {
//         ...updatedFormState,
//         language: parseInt(getKeyByValue(AddtoLanguages, formState.language)),
//       };
//       try {
//         const response = await api.put(
//           "students/update-student/",
//           newFormState,
//           {
//             headers: {
//               "Content-Type": "multipart/form-data",
//               Authorization: `Token ${token}`,
//             },
//           },
//         );

//         if (response?.data?.status === 200) {
//           updateState("student_details", response?.data ?? {});
//           setIsEditable(false);

//           toast.success(
//             response?.data?.message ||
//               "Student profile has been updated successfully.",
//             {
//               position: "top-center",
//             },
//           );
//         } else {
//           setIsEditable(false);
//           toast.error(response?.data?.message || "Something went wrong!", {
//             position: "top-center",
//           });
//         }
//       } catch (error) {
//         setIsEditable(false);
//         toast.error(
//           error?.response?.data?.message ||
//             error?.response?.data?.error ||
//             "Something went wrong!",
//           {
//             position: "top-center",
//           },
//         );
//       }
//     }
//   };

//   const [hasSelectedPlace, setHasSelectedPlace] = useState(
//     globalState.teacher_details?.data?.location ? true : false,
//   );

//   // ---------- Teacher inline edit ----------
//   const languageOptions = globalState.datalist?.languages ?? AddtoLanguages ?? {};

//   const cleanLanguageIds = (ids) =>
//     String(ids ?? "")
//       .split(",")
//       .filter((id) => id !== "" && id !== "null")
//       .join(",");

//   const isValidLinkUrl = (value) => {
//     try {
//       const url = new URL(/^https?:\/\//i.test(value) ? value : `https://${value}`);
//       return url.hostname.includes(".");
//     } catch {
//       return false;
//     }
//   };

//   // Seed the form from the latest teacher data every time edit starts (avoids stale values)
//   const startTeacherEdit = () => {
//     const d = globalState.teacher_details?.data ?? {};
//     setFormState((prev) => {
//       const { ai_avatar: _discard, ...rest } = prev;
//       return {
//         ...rest,
//         name: d.name,
//         title: d.title ? Object.keys(d.title)[0] : prev.title,
//         introduction: d.introduction,
//         email: d.email,
//         subject_names: Object.values(d.subjects || {}),
//         dob: d.dob,
//         gender: d.gender ? Object.keys(d.gender)[0] : prev.gender,
//         language_ids: cleanLanguageIds(
//           getIdsForLanguages(Object.values(d.language || {}), languageOptions),
//         ),
//         location: d.location,
//         linkedin_url: d.linkedin_url,
//         university: d.university ?? "",
//         experience: d.experience ?? "",
//       };
//     });
//     setEditLinks(getTeacherLinks(d).map((l) => l.url));
//     setPendingCertificates([]);
//     setSelectedImage(null);
//     setFormErrors({});
//     setHasSelectedPlace(!!d.location);
//     setIsEditable(true);
//   };

//   const cancelTeacherEdit = () => {
//     setFormState((prev) => {
//       const { ai_avatar: _discard, ...rest } = prev;
//       return rest;
//     });
//     setPendingCertificates([]);
//     setSelectedImage(null);
//     setFormErrors({});
//     setIsEditable(false);
//   };

//   const toggleLanguage = (id, isSelected) =>
//     isSelected ? removeLanguage(id) : addLanguage(id);

//   const validateTeacherForm = () => {
//     const name = formState.name ?? "";
//     const introduction = formState.introduction ?? "";
//     const experience = String(formState.experience ?? "").trim();
//     const linkErrors = editLinks.map((link) =>
//       link.trim() && !isValidLinkUrl(link.trim()) ? "• Please enter a valid URL." : "",
//     );

//     const errors = {
//       name: isRequired(name) || isValidName(name),
//       introduction: isRequired(introduction) || isMaxChar(introduction),
//       location: isRequired(formState.location ?? ""),
//       language: cleanLanguageIds(formState.language_ids) ? "" : "• Language is required.",
//       experience:
//         experience && (isNaN(experience) || +experience < 0 || +experience > 80)
//           ? "• Please enter valid years of experience."
//           : "",
//       links: linkErrors.some(Boolean) ? linkErrors : null,
//     };
//     setFormErrors(errors);
//     return !Object.values(errors).some(Boolean);
//   };

//   const saveTeacherProfile = async () => {
//     toast.dismiss();
//     if (!validateTeacherForm()) {
//       toast.error("Please fix the highlighted fields.", { position: "top-center" });
//       return;
//     }

//     const links = editLinks
//       .map((l) => l.trim())
//       .filter(Boolean)
//       .map((l) => (/^https?:\/\//i.test(l) ? l : `https://${l}`));
//     // Keep legacy linkedin_url in sync with the first valid LinkedIn link
//     const linkedinUrl =
//       links.find((l) => /linkedin\.com/i.test(l) && !isValidLinkedinUrl(l)) ?? "";

//     const payload = {
//       ...getUpdatedFields(),
//       language_ids: cleanLanguageIds(formState.language_ids),
//       subject_names: (formState.subject_names ?? []).join(","),
//       linkedin_url: linkedinUrl,
//       links: JSON.stringify(links),
//     };
//     if (String(payload.experience ?? "").trim() === "") delete payload.experience;

//     // Build FormData by hand so multiple certificate files go under the same key
//     const formData = new FormData();
//     Object.entries(payload).forEach(([key, value]) => {
//       if (value === null || value === undefined) return;
//       formData.append(key, value instanceof Blob ? value : String(value));
//     });
//     pendingCertificates.forEach((file) => formData.append("certificate", file));

//     setIsSaving(true);
//     try {
//       const response = await api.put(
//         `auth/update-teacher/?teacher_id=${globalState.teacher_details?.data?.teacher_id}`,
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//             Authorization: `Token ${token}`,
//           },
//         },
//       );
//       if (response?.data?.status === 200) {
//         updateState("teacher_details", response?.data ?? {});
//         setPendingCertificates([]);
//         setSelectedImage(null);
//         setIsEditable(false);
//         // Re-fetch so counts/ratings (not always in the update response) stay populated
//         fetchTeacherDetails();
//         toast.success(response?.data?.message || "Teacher profile has been updated successfully.", {
//           position: "top-center",
//         });
//       } else {
//         toast.error(response?.data?.message || "Something went wrong!", { position: "top-center" });
//       }
//     } catch (error) {
//       toast.error(
//         error?.response?.data?.message || error?.response?.data?.error || "Something went wrong!",
//         { position: "top-center" },
//       );
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   const handlePlaceSelect = (place) => {
//     if (place && place.formatted_address) {
//       setFormState((prev) => ({
//         ...prev,
//         location: place.formatted_address,
//       }));
//       setFormErrors({ location: "" });
//       setHasSelectedPlace(true);
//     } else {
//       setFormErrors({ location: "• Please enter a valid location" });
//     }
//   };

//   const handleAutocompleteInputChange = (event) => {
//     const value = event.target.value;

//     // Check if the value contains spaces
//     if (value.trim() === "") {
//       setFormErrors({ location: "• This field is required" });
//       setHasSelectedPlace(false);
//     } else {
//       setFormState((prev) => ({
//         ...prev,
//         location: value,
//       }));

//       // Check if the location is empty or if a place has not been selected
//       if (!hasSelectedPlace) {
//         setFormErrors({ location: "• Please enter a valid location" });
//       } else {
//         setFormErrors({ location: "" });
//       }
//     }
//   };

//   const handleInputBlur = () => {
//     if (!hasSelectedPlace && formState.location) {
//       setFormState((prev) => ({
//         ...prev,
//         location: "",
//       }));
//       setFormErrors({ location: "• Please enter a valid location" });
//     }
//   };

//   const addLanguage = (selectedLanguage) => {
//     let error = "";
//     error = isRequired(selectedLanguage);
//     if (!error) {
//       setFormErrors({
//         ...formErrors,
//         language: "", // Clear the error when a valid language is added
//       });
//     }
//     // add  language to formState.language string separated by comma
//     setFormState((prev) => ({
//       ...prev,
//       language_ids: prev.language_ids
//         ? prev.language_ids + "," + selectedLanguage
//         : selectedLanguage,
//     }));
//   };
//   const removeLanguage = (selectedLanguage) => {
//     let error = isRequired(selectedLanguage);
//     setFormErrors({
//       ...formErrors,
//       language_ids: error,
//     });

//     // Remove the selected language from formState.language string separated by a comma
//     setFormState((prev) => {
//       const updatedLanguageIds = prev.language_ids
//         ?.split(",")
//         ?.filter((item) => item !== selectedLanguage)
//         .join(",");
//       return {
//         ...prev,
//         language_ids: updatedLanguageIds,
//       };
//     });
//   };

//   const [modalIsOpen, setModalIsOpen] = useState(false);
//   const [isAddToSubjetModelOpen, setIsAddToSubjetModelOpen] = useState(false);
//   const [src, setSrc] = useState(null);
//   const handleFileInput = async (event) => {
//     const errorKey = isTeacher ? "ai_avatar" : "student_profile_pic";
//     const file = event.target.files[0];

//     if (!file) {
//       setSrc(null);
//       return;
//     }

//     if (file.size > 31457280) {
//       // Handle the case where the file size is too large
//       toast.error("The file size exceeds the maximum limit of 1 MB");
//       setFormErrors({
//         ...formErrors,
//         [errorKey]: "The file size exceeds the maximum limit of 1 MB",
//       });
//       setSrc(null);
//       return; // Exit the function
//     }

//     const compressedImage = await compressImage(file);
//     setSrc(URL.createObjectURL(compressedImage));
//     onOpenModal();

//     let error = "";
//     error = isRequired(file);
//     setFormErrors({
//       ...formErrors,
//       [errorKey]: error,
//     });
//     event.target.value = null;
//   };

//   const onOpenModal = () => {
//     setModalIsOpen(true);
//   };

//   const onCloseModal = () => {
//     setModalIsOpen(false);
//   };

//   const handleSaveForm = (event) => {
//     event.preventDefault();

//     // Validate the LinkedIn URL
//     if (isTeacher) {
//       const linkedinError = isValidLinkedinUrl(formState.linkedin_url);
//       if (linkedinError) {
//         setFormErrors({
//           ...formErrors,
//           linkedin_url: linkedinError,
//         });
//         return; // Prevent saving if LinkedIn URL is invalid
//       }
//     }

//     // Check if language is empty
//     if (isTeacher) {
//       if (!formState.language_ids || formState.language_ids.trim() === "") {
//         setFormErrors({
//           ...formErrors,
//           language: "• Language is required.",
//         });
//         return; // Prevent saving if language is empty
//       }
//     }

//     handleForm4Submit();
//   };

//   function fetchTeacherDetails() {
//     api
//       .get("/auth/get-teacher/", {
//         headers: {
//           "Content-Type": "multipart/form-data",
//           Authorization: `Token ${token}`,
//         },
//       })
//       .then((response) => {
//         if (response.status === 200) {
//           if (response?.data) {
//             updateState("teacher_details", response?.data ?? {});
//             if(response?.data?.currency_symbol) {
//             updateState("currency_symbol",response?.data?.currency_symbol)
//             }

//           }
//         }
//       })
//       .catch((error) => {
//         console.error("Failed to fetch teacher details:", error);
//       });
//   }

//   useEffect(() => {
//     fetchTeacherDetails();
//   }, [token]);

//   useEffect(() => {
//     if (!isTeacher) {
//       api
//         .get("/courses/get-grade-list/", {
//           headers: {
//             "Content-Type": "multipart/form-data",
//             Authorization: `Token ${token}`,
//           },
//         })
//         .then((response) => {
//           if (response.status === 200) {
//             setGradedetails(response.data.grade);
//           }
//         })
//         .catch((error) => {});
//     }
//   }, [token]);
//   const lastGradeUpdate = new Date(
//     globalState?.student_details?.data?.grade_last_update,
//   );
//   const currentDate = new Date();

//   // Calculate the difference in time
//   const timeDiff = currentDate.getTime() - lastGradeUpdate.getTime();

//   // Convert time difference to days
//   const daysDiff = timeDiff / (1000 * 3600 * 24);

//   // Determine if the select should be read-only
//   const isReadOnly = daysDiff < 14;
//   const googleToken = useSelector((state) => state.submitGoogleToken);
//   const googleAccessToken = useSelector((state) => state.getGoogleAccessToken);
//   const unLinkgdrive = useSelector((state) => state.unlinkgdrive);
//   const linkGDriveState = useSelector((state) => state.linkgdrive);

//   const onSuccess = async (tokenResponse) => {
//     const response = await fetch("https://oauth2.googleapis.com/token", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/x-www-form-urlencoded",
//       },
//       body: new URLSearchParams({
//         code: tokenResponse.code,
//         client_id: process.env.REACT_APP_GOOGLEDRIVE_CLIENTID,
//         client_secret: process.env.REACT_APP_GOOGLEDRIVE_SECRET_KEY,
//         redirect_uri: process.env.REACT_APP_SHARE_URL.replace(/\/$/, ""),
//         // redirect_uri: process.env.REACT_APP_SHARE_URL,
//         // Ensure this matches with your console setup
//         grant_type: "authorization_code",
//         access_type: "offline",
//       }),
//     });

//     const tokenData = await response.json();

//     if (tokenData) {
//       const creds = {
//         google_token: {
//           token: tokenData.access_token,
//           refresh_token: tokenData.refresh_token || null,
//           token_uri: "https://oauth2.googleapis.com/token",
//           client_id: process.env.REACT_APP_GOOGLEDRIVE_CLIENTID,
//           client_secret: process.env.REACT_APP_GOOGLEDRIVE_SECRET_KEY,
//           scopes: tokenResponse.scope ? tokenData.scope.split(" ") : [],
//           expiry: new Date(
//             Date.now() + tokenData.expires_in * 1000,
//           ).toISOString(),
//         },
//       };
//       handleLogin(creds);
//       setTimeout(() => {
//         dispatch(linkGDrive(token, null));
//       }, 50);
//     }
//   };

//   const onFailure = (error) => {
//     console.error("Login failed:", error);
//   };

//   const handleLogin = (req) => {
//     dispatch(submitGoogleToken(req, token));
//   };

//   const unLinkGDrive = () => {
//     dispatch(unlinkGDrive(token));
//   };
//   const loginWithGoogle = useGoogleLogin({
//     onSuccess,
//     onError: onFailure, // Changed from onFailure to onError as per the GIS library
//     scope: [
//       "https://www.googleapis.com/auth/drive.file",
//       "https://www.googleapis.com/auth/drive",
//       "https://www.googleapis.com/auth/drive.metadata.readonly",
//       "https://www.googleapis.com/auth/drive.metadata",
//     ].join(" "),
//     access_type: "offline",
//     approval_prompt: "force",
//     prompt: "consent",
//     flow: "auth-code",
//   });

//   useEffect(() => {
//     if (linkGDriveState.message !== null) {
//       toast.success("Drive linked Successfully");

//       dispatch(resetlinkGoogleDrive());
//     }

//     if (googleToken?.google_token !== null || unLinkgdrive.message !== null) {
//       dispatch(getGoogleTokenAction(token));
//     }
//     if (unLinkgdrive.message !== null) {
//       toast.success("Drive Unlinked Successfully");
//     }
//     return () => {
//       dispatch(resetsubmitgoogleToken());
//       dispatch(resetunlinkGoogleDrive());
//       // dispatch(resetlinkGoogleDrive())
//     };
//   }, [googleToken, unLinkgdrive, linkGDriveState]);

//   const onEdit = () => {
//     console.log("edit");
//   };

//   return (
//     <>
//       {isTeacher ? (
//         // Redesigned teacher profile; view + inline edit share one layout
//         <TeacherProfileView
//           teacher={globalState.teacher_details?.data ?? {}}
//           token={token}
//           avatar={selectedImage ?? ai_avatar}
//           isEditing={isEditable}
//           onEdit={startTeacherEdit}
//           onUploadFile={() => setUploadFileModal(true)}
//           onAddSpecialization={() => setIsAddToSubjetModelOpen(true)}
//           edit={{
//             form: formState,
//             errors: formErrors,
//             onChange: handleInputChange,
//             location: {
//               onPlaceSelect: handlePlaceSelect,
//               onChange: handleAutocompleteInputChange,
//               onBlur: handleInputBlur,
//             },
//             languageOptions,
//             onToggleLanguage: toggleLanguage,
//             onAvatarSelect: handleFileInput,
//             links: editLinks,
//             setLinks: setEditLinks,
//             pendingCertificates,
//             onAddCertificates: (files) =>
//               setPendingCertificates((prev) => [...prev, ...files]),
//             onRemoveCertificate: (idx) =>
//               setPendingCertificates((prev) => prev.filter((_, i) => i !== idx)),
//             onCancel: cancelTeacherEdit,
//             onSave: saveTeacherProfile,
//             saving: isSaving,
//           }}
//         />
//       ) : (
//     <div className="account_setting_tab_sec">
//       <div className="account_setting_tab_sec_head">
//         <h6>Account Settings</h6>
//         {isEditable ? (
//           <button
//             className="save_btn_set"
//             onClick={handleSaveForm}
//             disabled={
//               !!formErrors.introduction ||
//               !!formErrors.name ||
//               !!formErrors.location
//             }
//           >
//             Save
//           </button>
//         ) : (
//           <div className="flex gap-2">
//             {isTeacher && 
//             <UploadFileBtn handleClick={() => {
//                 setUploadFileModal(true);
//               }}/>
//             }
//             <PrimaryBtn
//               py="py-[9px]"
//               icon={<i class="fa-solid fa-pen" />}
//               label="Edit"
//               handleClick={() => setIsEditable(true)}
//             />
//           </div>
//         )}
//       </div>
//       <div
//         style={{
//           pointerEvents: isEditable ? "auto" : "none",
//         }}
//       >
//         <div className="about_teach_sec_new">
//           <div className="about_teach_sec_new_left">
//             <div className="Personalize-your-AI-Assistant-uplode-image">
//               <img src={selectedImage ?? ai_avatar ?? upload_image} alt="" />
//               <div
//                 className="profile_plus_icon"
//                 onChange={() => {}}
//                 style={{ cursor: "pointer" }}
//               >
//                 {isEditable && (
//                   <span>
//                     <i class="fa-solid fa-plus"></i>
//                   </span>
//                 )}
//               </div>
//               <input
//                 type="file"
//                 id="choos-profile-image"
//                 name="student_profile_pic"
//                 accept="image/png, image/jpeg"
//                 style={{
//                   height: 106,
//                   width: 106,
//                 }}
//                 onChange={handleFileInput}
//               />
//             </div>
//             <h5 style={{ textAlign: "center" }}>{formState.name}</h5>
//           </div>
//           <div className="about_teach_sec_new_right">
//             <h4> {isTeacher ? "About Teacher" : "About Student"}</h4>
//             <textarea
//               name="introduction"
//               style={
//                 formErrors.introduction ? { border: "1px solid red" } : null
//               }
//               value={formState.introduction || ""}
//               onChange={handleInputChange}
//               className="introduce-yourself-text"
//               maxlength="1000"
//               type="text"
//               cols="20"
//               rows="5"
//               placeholder={`For Example:\n• Tell us about yourself.\n• What subjects do you teach?\n• What grades do you teach?\n• Do you teach at a school? If so, which one?`}
//               inputprops={{
//                 style: { color: "red" },
//               }}
//             ></textarea>
//             <p className="errorState">{formErrors.introduction}</p>
//           </div>
//         </div>
//         {isTeacher && (
//           <>
//             <div
//               className="profile_linkedin"
//               style={{
//                 pointerEvents: "auto",
//               }}
//             >
//               <div className="profile_linkedin_image">
//                 <img src={devicon_linkedin} />
//               </div>
//               {isEditable ? (
//                 <input
//                   type="text"
//                   placeholder="linkedin"
//                   name="linkedin_url"
//                   value={formState.linkedin_url || ""}
//                   onChange={handleInputChange}
//                 />
//               ) : (
//                 <a href={formState.linkedin_url} target="_blank">
//                   {formState?.linkedin_url ?? "-"}
//                 </a>
//               )}
//             </div>

//             <p className="form-error" style={{ marginTop: "8px" }}>
//               {formErrors.linkedin_url}
//             </p>
//           </>
//         )}
//         <div className="subject_special">
//           <Grid container xs={12} justifyContent={"space-between"}>
//             <h5>{isTeacher ? "Subjects" : "Interest"}</h5>
//             {isEditable && (
//               <button
//                 className="edit_btn_set"
//                 onClick={() => setIsAddToSubjetModelOpen(true)}
//               >
//                 {isTeacher ? "Add Subject" : "Add Interest"}
//               </button>
//             )}
//           </Grid>
//           <ul className="sub_special">
//             {isTeacher
//               ? formState.subject_names &&
//                 formState.subject_names?.map((subject) => (
//                   <li key={subject}>{subject}</li> // Use the subject as key if it's unique
//                 ))
//               : formState.interest_names &&
//                 formState.interest_names?.map((subject) => (
//                   <li key={subject}>{subject}</li> // Use the subject as key if it's unique
//                 ))}
//           </ul>
//         </div>
//         <div
//           className="form_sec_settings"
//           style={{
//             pointerEvents: isEditable ? "auto" : "none",
//           }}
//         >
//           <div
//             className="dashboard-popup-teacher-profile-details-form"
//             style={{
//               backgroundColor: "transparent",
//               width: "60%",
//               padding: "0px",
//             }}
//           >
//             <div className="dashboard-popup-teacher-profile-details-form-container">
//               <div className="dashboard-popup-teacher-profile-details-input">
//                 <label>Name</label>
//                 <input
//                   id="teacher-create-profile-input"
//                   type="name"
//                   name="name"
//                   style={formErrors.name ? { border: "1px solid red" } : null}
//                   value={formState.name || ""}
//                   placeholder="Full name"
//                   onChange={handleInputChange}
//                 />
//                 <div className="teacher-create-popup-gender-input-folder">
//                   <div className="form-icon">
//                     <img src={profile_image} alt="" />
//                   </div>
//                   <div className="setect-genter-list-dropdown">
//                     {isTeacher && (
//                       <select
//                         name="title"
//                         className="teacher-create-popup-gender-input"
//                         style={
//                           formErrors.title ? { border: "1px solid red" } : null
//                         }
//                         value={formState.title || ""}
//                         onChange={handleInputChange}
//                       >
//                         {titles.map((title) => {
//                           return (
//                             <option key={title.value} value={title.value}>
//                               {title.name}
//                             </option>
//                           );
//                         })}
//                       </select>
//                     )}
//                   </div>
//                 </div>
//                 <p>{formErrors.name}</p>
//               </div>
//               {!isTeacher && (
//                 <div className="dashboard-popup-teacher-profile-details-input">
//                   <label>Grade</label>
//                   <select
//                     name="grade"
//                     style={
//                       formErrors.grade
//                         ? {
//                             border: "1px solid red",
//                             borderRadius: 6,
//                           }
//                         : {
//                             border: "1px solid #BDBDBD",
//                             borderRadius: 6,
//                           }
//                     }
//                     value={formState.grade || ""}
//                     onChange={handleInputChange}
//                     readOnly={isReadOnly}
//                     disabled={isReadOnly}
//                   >
//                     <option value="">Select Grade</option>
//                     {Object.keys(gradedetails).map((key) => (
//                       <option key={`gradedetails${key}`} value={key}>
//                         {gradedetails[key]}
//                       </option>
//                     ))}
//                   </select>
//                   <div className="form-icon grade_icon">
//                     <img src={grade_image} alt="" />
//                   </div>
//                   <p>{formErrors.grade}</p>
//                 </div>
//               )}
//               <div className="dashboard-popup-teacher-profile-details-input">
//                 <label>Email</label>
//                 <input
//                   type="text"
//                   placeholder="email id"
//                   name="email"
//                   readOnly
//                   style={formErrors.email ? { border: "1px solid red" } : null}
//                   value={formState.email || ""}
//                   onChange={handleInputChange}
//                 />
//                 <div className="form-icon">
//                   <img src={email_image} alt="" />
//                 </div>
//                 <p>{formErrors.email}</p>
//               </div>
//               <div className="dashboard-popup-teacher-profile-details-input">
//                 <label>Birth Date</label>
//                 {isEditable ? (
//                   <Datetime
//                     name="dob"
//                     className={formErrors.dob ? "datetime-error" : "datetime"}
//                     timeFormat={false}
//                     inputProps={{
//                       placeholder: "MM/DD/YYYY",
//                       value: dobInputValue,
//                       onChange: handleDobInput,
//                       onBlur: () => {
//                         if (dobInputValue.length > 0 && dobInputValue.length < 10) {
//                           setFormErrors((prev) => ({ ...prev, dob: "Please enter complete date (MM/DD/YYYY)" }));
//                         }
//                       },
//                       maxLength: 10,
//                       style: formErrors.dob ? { border: "1px solid red" } : null,
//                     }}
//                     value={dobInputValue}
//                     closeOnSelect={true}
//                     onChange={(date) => {
//                       if (typeof date === "object" && date?.isValid && date.isValid()) {
//                         const selectedDate = date.toDate();
//                         const today = new Date();
//                         const minDate = new Date();
//                         minDate.setFullYear(today.getFullYear() - (isTeacher ? 21 : 4));
//                         if (selectedDate > today) {
//                           setFormErrors((prev) => ({ ...prev, dob: "Date of birth cannot be in the future" }));
//                           return;
//                         }
//                         if (selectedDate > minDate) {
//                           setFormErrors((prev) => ({ ...prev, dob: isTeacher ? "Teacher must be at least 21 years old" : "Student must be at least 4 years old" }));
//                           return;
//                         }
//                         setDobInputValue(date.format("MM/DD/YYYY"));
//                         setFormState((prev) => ({ ...prev, dob: date.format("YYYY-MM-DD") }));
//                         setFormErrors((prev) => ({ ...prev, dob: "" }));
//                       }
//                     }}
//                     dateFormat="MM/DD/YYYY"
//                     isValidDate={isTeacher ? isValidDateTeacher : isValidDateStudent}
//                   />
//                 ) : (
//                   <p className="w-full px-[10px] py-2 pl-[38px] text-[12px] border border-[#bdbdbd] rounded-[6px] !bg-transparent !text-black">{formState.dob ? getFormattedDate(formState.dob) : "—"}</p>
//                 )}
//                 <div className="form-icon"><img src={calender_image} alt="" /></div>
//                 <p>{formErrors.dob}</p>
//               </div>
//               <div className="dashboard-popup-teacher-profile-details-input">
//                 <label>Gender</label>
//                 <div className="dashboard-popup-teacher-profile-gender-folder">
//                   <select
//                     name="gender"
//                     style={
//                       formErrors.gender ? { border: "1px solid red" } : null
//                     }
//                     value={
//                       Number.isInteger(parseInt(formState.gender))
//                         ? formState.gender
//                         : getKeyByValue(
//                             ["Choose Other", "Male", "Female", "Other"],
//                             formState.gender,
//                           ) || ""
//                     }
//                     onChange={handleInputChange}
//                   >
//                     {genders.map((gender) => {
//                       return (
//                         <option key={gender.value} value={gender.value}>
//                           {gender.name}
//                         </option>
//                       );
//                     })}
//                   </select>
//                 </div>
//                 <div className="form-icon">
//                   <img src={gender_image} alt="" />
//                 </div>
//                 <p>{formErrors.gender}</p>
//               </div>
//               {!isTeacher && (
//                 <div className="dashboard-popup-teacher-profile-details-input">
//                   <label>Language</label>
//                   <div className="dashboard-popup-teacher-profile-gender-folder">
//                     <select
//                       name="language"
//                       style={
//                         formErrors.language
//                           ? {
//                               border: "1px solid red",
//                               borderRadius: 6,
//                             }
//                           : {
//                               border: "1px solid #BDBDBD",
//                               borderRadius: 6,
//                             }
//                       }
//                       value={formState.language || ""}
//                       onChange={handleInputChange}
//                     >
//                       <option value="">Select Language</option>
//                       {Object.keys(AddtoLanguages)
//                         .map((key) => key)
//                         .map((key) => (
//                           <option key={key} value={AddtoLanguages[key]}>
//                             {AddtoLanguages[key]}
//                           </option>
//                         ))}
//                     </select>
//                   </div>
//                   <div className="form-icon">
//                     <img src={language_image} alt="" />
//                   </div>
//                   <p>{formErrors.language}</p>{" "}
//                 </div>
//               )}
//               <div className="dashboard-popup-teacher-profile-details-input">
//                 <label>Location</label>
//                 <Autocomplete
//                   apiKey={GOOGLE_MAP_KEY}
//                   onPlaceSelected={handlePlaceSelect}
//                   defaultValue={formState.location}
//                   onChange={handleAutocompleteInputChange}
//                   onBlur={handleInputBlur}
//                   options={{
//                     types: ["(cities)"],
//                   }}
//                 />
//                 <div className="form-icon location-icon">
//                   <img src={location_image} alt="" />
//                 </div>
//                 <p>{formErrors.location}</p>
//               </div>
//             </div>
//             {isTeacher && (
//               <div className="dashboard-popup-teacher-profile-details-input location-input">
//                 <label>
//                   Language {isEditable && <span>(Select Language)</span>}
//                 </label>
//                 <div className="dashboard-popup-teacher-profile-select-Language-container">
//                   {isEditable && (
//                     <div className="Subjects-you-teach-suggestions-folder">
//                       {Object.keys(globalState?.datalist?.languages)
//                         .filter((key) => {
//                           const languageName =
//                             globalState.datalist.languages[key];
//                           const languageId = parseInt(key);
//                           return (
//                             !formState.language_ids.includes(languageName) &&
//                             !formState.language_ids.includes(languageId)
//                           );
//                         })
//                         .map((key) => (
//                           <a
//                             // href="#"
//                             key={key}
//                             onClick={() => addLanguage(key)}
//                           >
//                             {globalState?.datalist?.languages[key]}
//                           </a>
//                         ))}
//                     </div>
//                   )}
//                   {globalState?.datalist?.languages &&
//                     (formState.language_ids ?? "")
//                       .split(",")
//                       .filter((language) => language !== "").length > 0 && (
//                       <div className="dashboard-popup-teacher-profile-selected-Language-folder">
//                         <div className="Subjects-you-teach-feilds-folder">
//                           {formState.language_ids
//                             .split(",")
//                             .filter((language) => language !== "")
//                             .map((language) => {
//                               const languageKey = String(language); // Ensure language is a string
//                               return (
//                                 <div
//                                   className="Subjects-you-teach-feilds"
//                                   key={languageKey}
//                                 >
//                                   <p>
//                                     {globalState?.datalist?.languages[
//                                       languageKey
//                                     ] ??
//                                       globalState?.datalist?.languages[
//                                         getKeyByValue(
//                                           globalState?.datalist?.languages,
//                                           languageKey,
//                                         )
//                                       ]}
//                                   </p>
//                                   {isEditable && (
//                                     <a
//                                       className="subject-delete-btn"
//                                       onClick={() =>
//                                         removeLanguage(languageKey)
//                                       }
//                                     >
//                                       <i className="fa-solid fa-xmark"></i>
//                                     </a>
//                                   )}
//                                 </div>
//                               );
//                             })}
//                         </div>
//                       </div>
//                     )}
//                 </div>
//                 <p>{formErrors.language}</p>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//       )}
//       {modalIsOpen && (
//         <CropProfileImageModal
//           src={src}
//           setSrc={setSrc}
//           setSelectedImage={setSelectedImage}
//           setImageUploaded={setImageUploaded}
//           setUplodedImage={setUplodedImage}
//           modalStatus={modalIsOpen}
//           setModalClose={onCloseModal}
//           fieldName={isTeacher ? "ai_avatar" : "student_profile_pic"}
//           setFormState={setFormState}
//           formState={formState}
//         />
//       )}
//       {isAddToSubjetModelOpen && (
//         <EditSubject
//           subject_title="Subjects you are interested in"
//           modalStatus={isAddToSubjetModelOpen}
//           subjectlist={Object.values(
//             isTeacher
//               ? formState.subject_names ?? []
//               : Object.values(
//                   globalState.student_details?.data?.interest || {},
//                 ) || {},
//           )}
//           setModalClose={() => setIsAddToSubjetModelOpen(false)}
//           onClose={() => setIsAddToSubjetModelOpen(false)}
//           onSubmit={(subjects) => {
//             setFormState((prev) => ({
//               ...prev,
//               [subjectsKey]: subjects,
//             }));
//             setIsAddToSubjetModelOpen(false);
//           }}
//         />
//       )}
//       {isTeacher && (
//         <ProfileModal
//           open={uploadFileModal}
//           close={() => setUploadFileModal(false)}
//         />
//       )}
//     </>
//   );
// }

// export default Profile;









import { Grid } from "@mui/material";
import { allCountries } from "country-telephone-data";
import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import Datetime from "react-datetime";
import Autocomplete from "react-google-autocomplete";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import api from "../../../../../api/api";
import {
  calender_image,
  email_image,
  gender_image,
  grade_image,
  language_image,
  location_image,
  profile_image,
  upload_image,
  devicon_linkedin,
} from "../../../../../assets/images/images";
import EditSubject from "../../../../../components/EditSubject.js/EditSubject";
import { GOOGLE_MAP_KEY } from "../../../../../consts/constants";
import { useAuth } from "../../../../../features/auth/AuthContext";
import { updateGlobalState } from "../../../../../state/global/slice";
import { compressImage } from "../../../../../utils/CompressImage";
import { genders, titles } from "../../../../../utils/consts";
import { getIdsForLanguages, getKeyByValue } from "../../../../../utils/utlis";
import {
  isMaxChar,
  isRequired,
  isValidLinkedinUrl,
  isValidMobileNumber,
  isValidName,
} from "../../../../../utils/validator";
import CropProfileImageModal from "../../dashboard/CropProfileImageModal";
// import { google_drive_logo, connection_icon, sync_icon, notConnectedIcon } from "../../../../../assets/images/images";
import {
  submitGoogleToken,
  resetsubmitgoogleToken,
} from "../../../../../state/actions/submitGoogleTokenAction";
import {
  getGoogleTokenAction,
  resetGoogleToken,
} from "../../../../../state/actions/getGoogleTokenAction";
import {
  unlinkGDrive,
  resetunlinkGoogleDrive,
} from "../../../../../state/actions/unlinkGoogleDriveAction";
import {
  linkGDrive,
  resetlinkGoogleDrive,
} from "../../../../../state/actions/linkGoogleDriveAction";
import { useGoogleLogin } from "@react-oauth/google";
import PrimaryBtn from "../../../../../components/Buttons/PrimaryBtn";
import CustomModal from "../../../../../components/CustomModal/CustomModal";
import Header from "../../../../../components/FileRepo/Components/Header";
import DataTable, {
  DeleteAction,
  DownloadAction,
  EditAction,
  FavouriteAction,
  MoveAction,
  RowActionsTray,
} from "../../../../../components/FileRepo/Components/DataTable";
import { fileIcons } from "../../../../../components/FileRepo/Icons";
import { formatFileSize } from "../../../../../components/FileRepo/utils/utils";
import { getFileActions } from "../../../../../components/FileRepo/utils/fileActions";
import ProfileModal from "../../../../../components/FileRepo/FileActions/ProfileModal";
import UploadFileBtn from "../../../../../components/FileRepo/Components/Buttons/UploadFileBtn";
import dayjs from "dayjs";

function Profile() {
  const { token } = useAuth();
  const globalState = useSelector((state) => state.globalState);
  const isTeacher = globalState.role === "Teacher";

  const updateState = (key, value) => {
    dispatch(updateGlobalState({ key: key, value: value }));
  };
  const dispatch = useDispatch();
  const [selectedFile, setSelectedFile] = useState(null);

  const today = new Date().toISOString().split("T")[0];
  const [isEditable, setIsEditable] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageUploaded, setImageUploaded] = useState(false);
  const [uplodedImage, setUplodedImage] = useState({});
  const [uploadFileModal, setUploadFileModal] = useState(false);
  const getFormattedDate = (isoDate) => {
    const dateObj = new Date(isoDate);
    const options = { year: "numeric", month: "short", day: "numeric" };
    return dateObj.toLocaleDateString("en-US", options); // Converts to a format like "Oct 18, 2023"
  };
  const ai_avatar = isTeacher
    ? globalState.teacher_details?.data?.ai_avatar
    : globalState.student_details?.data?.student_profile_pic;
  const [AddtoLanguages, setAddtoLanguages] = useState(
    globalState.datalist?.languages ? globalState.datalist?.languages : [],
  );
  useEffect(() => {
    // api
    //   .get("/auth/get-datalist/")
    //   .then((response) => {
    //     setAddtoLanguages(response.data.languages);
    //     updateState("datalist", response?.data ?? {});
    //   })
    //   .catch((error) => {
    //   });
  }, []);
  const [gradedetails, setGradedetails] = useState([]);
  const subjectsKey = isTeacher ? "subject_names" : "interest_names";

  const [formState, setFormState] = useState({
    name: isTeacher
      ? globalState.teacher_details?.data?.name
      : globalState.student_details?.data?.name,
    title: isTeacher
      ? Object.keys(globalState.teacher_details?.data?.title)[0]
      : globalState.student_details?.data?.title,
    grade: isTeacher
      ? null
      : Object.keys(globalState.student_details?.data?.grade)[0],
    introduction: isTeacher
      ? globalState.teacher_details?.data?.introduction
      : globalState.student_details?.data?.introduction,
    email: isTeacher
      ? globalState.teacher_details?.data?.email
      : globalState.student_details?.data?.email,
    [subjectsKey]: isTeacher
      ? Object.values(globalState.teacher_details?.data?.subjects || {})
      : Object.values(globalState.student_details?.data?.interest || {}),
    dob: isTeacher
      ? globalState.teacher_details?.data?.dob
      : globalState.student_details?.data?.dob,
    gender: Object.keys(
      isTeacher
        ? globalState.teacher_details?.data?.gender
        : globalState.student_details?.data?.gender,
    )[0],
    language_ids:
      isTeacher && Object.values(AddtoLanguages)
        ? getIdsForLanguages(
            Object.values(globalState.teacher_details?.data?.language),
            AddtoLanguages,
          )
        : null,
    language: !isTeacher
      ? Object.values(globalState.student_details?.data?.language)?.join(",")
      : null,
    location: isTeacher
      ? globalState.teacher_details?.data?.location
      : globalState.student_details?.data?.location,
    linkedin_url: isTeacher
      ? globalState.teacher_details?.data?.linkedin_url
      : null,
  });
  const [formErrors, setFormErrors] = useState({
    name: "",
    grade: "",
    introduction: "",
    lastname: "",
    email: "",
    dob: "",
    gender: "",
    location: "",
    language: "",
    title: "",
  });

  const [selectedCountry, setSelectedCountry] = useState({
    name: "United States",
    iso2: "us",
    dialCode:
      globalState.teacher_details?.data?.country_code &&
      globalState.teacher_details?.data?.country_code.replace(/\+/g, ""),
    format: "+...-...-....",
    hasAreaCodes: false,
  });

const [dobInputValue, setDobInputValue] = useState(() => {
  if (!formState.dob) return "";
  const parsed = dayjs(formState.dob);
  return parsed.isValid() ? parsed.format("MM/DD/YYYY") : "";
});

const handleDobInput = (e) => {
  const raw = e.target.value;

  if (raw.length < dobInputValue.length) {
    setDobInputValue(raw);
    if (raw.length < 10) setFormState((prev) => ({ ...prev, dob: "" }));
    return;
  }

  let digits = raw.replace(/\D/g, "");
  let value = digits;
  if (digits.length >= 3 && digits.length <= 4) {
    value = digits.slice(0, 2) + "/" + digits.slice(2);
  } else if (digits.length >= 5) {
    value = digits.slice(0, 2) + "/" + digits.slice(2, 4) + "/" + digits.slice(4, 8);
  }

  setDobInputValue(value);

  if (value.length === 10) {
    const parsed = dayjs(value, "MM/DD/YYYY", true);
    if (!parsed.isValid()) {
      setFormErrors((prev) => ({ ...prev, dob: "Please enter a valid date (MM/DD/YYYY)" }));
      setFormState((prev) => ({ ...prev, dob: "" }));
      return;
    }
    const today = new Date();
    const selectedDate = parsed.toDate();
    const minDate = new Date();
    minDate.setFullYear(today.getFullYear() - (isTeacher ? 21 : 4));

    if (selectedDate > today) {
      setFormErrors((prev) => ({ ...prev, dob: "Date of birth cannot be in the future" }));
      setFormState((prev) => ({ ...prev, dob: "" }));
      return;
    }
    if (selectedDate > minDate) {
      setFormErrors((prev) => ({ ...prev, dob: isTeacher ? "Teacher must be at least 21 years old" : "Student must be at least 4 years old" }));
      setFormState((prev) => ({ ...prev, dob: "" }));
      return;
    }
    setFormState((prev) => ({ ...prev, dob: parsed.format("YYYY-MM-DD") }));
    setFormErrors((prev) => ({ ...prev, dob: "" }));
  } else {
    setFormState((prev) => ({ ...prev, dob: "" }));
    setFormErrors((prev) => ({ ...prev, dob: "" }));
  }
};

  function isValidDateTeacher(val) {
    let today = new Date();
    let twentyOneYearsAgo = new Date();
    twentyOneYearsAgo.setFullYear(today.getFullYear() - 21);
    twentyOneYearsAgo.setHours(0, 0, 0, 0); // Set time to the start of the day

    let selectedDate = new Date(val);
    selectedDate.setHours(0, 0, 0, 0); // Set time to the start of the day

    // Check if the selected date is after today or if it is less than 21 years ago
    if (selectedDate > today || selectedDate > twentyOneYearsAgo) {
      return false;
    }
    return true;
  }

  function isValidDateStudent(val) {
    let today = new Date();
    let twentyOneYearsAgo = new Date();
    twentyOneYearsAgo.setFullYear(today.getFullYear() - 4);
    twentyOneYearsAgo.setHours(0, 0, 0, 0); // Set time to the start of the day

    let selectedDate = new Date(val);
    selectedDate.setHours(0, 0, 0, 0); // Set time to the start of the day

    // Check if the selected date is after today or if it is less than 21 years ago
    if (selectedDate > today || selectedDate > twentyOneYearsAgo) {
      return false;
    }
    return true;
  }

  const handleDateChanged = (value) => {
    let error = "";
    error = isRequired(value);
    setFormErrors({
      ...formErrors,
      dob: error,
    });
    setFormState((prev) => ({
      ...prev,
      dob: format(new Date(value), "yyyy-MM-dd"),
    }));
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    let error = "";

    // Trim whitespace and validate
    if (value.trim() === "") {
      if (name !== "linkedin_url") {
        error = "• This field is required";
      }
    } else {
      if (name === "name") {
        error = isRequired(value) || isValidName(value);
      } else if (name === "title") {
        error = value === "" || value === "0" ? "Please select title" : "";
      } else if (name === "introduction") {
        error = isRequired(value) || isMaxChar(value);
      } else if (name === "lastname") {
        error = isRequired(value);
      } else if (name === "grade") {
        error = isRequired(value);
      } else if (name === "email") {
        error = isRequired(value);
      } else if (name === "dob") {
        error = isRequired(value);
      } else if (name === "gender") {
        error = value === "" || value === "0" ? "• Please select gender" : "";
      } else if (name === "location") {
        error = isRequired(value);
      } else if (name === "language") {
        error = isRequired(value);
      } else if (name === "country_code") {
        error = isValidMobileNumber(value, selectedCountry.dialCode);
      } else if (name === "linkedin_url") {
        error = isValidLinkedinUrl(value);
      }
    }

    if (name === "linkedin_url" && value.trim() !== "") {
      setFormErrors({
        ...formErrors,
        linkedin_url: "", // Clear error when a valid LinkedIn URL is entered
      });
    }

    // Clear the error if the language field is filled
    if (name === "language" && value.trim() !== "") {
      setFormErrors({
        ...formErrors,
        language: "", // Clear error when a valid language is selected
      });
    }

    setFormErrors({
      ...formErrors,
      [name]: error,
    });

    setFormState((prev) => ({ ...prev, [name]: value }));
  };

  const getUpdatedFields = () => {
    const updatedFields = Object.entries(formState).reduce(
      (result, [key, value]) => {
        const teacherValue = globalState.teacher_details?.data[key];
        const studentValue = globalState.student_details?.data[key];

        // Check if the value is not null and different from teacherValue and studentValue
        if (
          value !== teacherValue &&
          value !== studentValue &&
          value !== null
        ) {
          result[key] = value;
        }

        return result;
      },
      {},
    );

    return updatedFields;
  };
  const handleForm4Submit = async (e) => {
    await submitForm();
  };
  const submitForm = async () => {
    toast.dismiss();
    const updatedFormState = {
      ...getUpdatedFields(),
      [subjectsKey]: formState[subjectsKey]?.join(","),
    };
    if (isTeacher) {
      try {
        const response = await api.put(
          `auth/update-teacher/?teacher_id=${globalState.teacher_details?.data?.teacher_id}`,
          updatedFormState,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Token ${token}`,
            },
          },
        );

        if (response?.data?.status === 200) {
          updateState("teacher_details", response?.data ?? {});
          setIsEditable(false);

          toast.success(
            response?.data?.message ||
              "Teacher profile has been updated successfully.",
            {
              position: "top-center",
            },
          );
        } else {
          setIsEditable(false);
          toast.error(response?.data?.message || "Something went wrong!", {
            position: "top-center",
          });
        }
      } catch (error) {
        setIsEditable(false);
        toast.error(
          error?.response?.data?.message ||
            error?.response?.data?.error ||
            "Something went wrong!",
          {
            position: "top-center",
          },
        );
      }
    } else {
      const newFormState = {
        ...updatedFormState,
        language: parseInt(getKeyByValue(AddtoLanguages, formState.language)),
      };
      try {
        const response = await api.put(
          "students/update-student/",
          newFormState,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Token ${token}`,
            },
          },
        );

        if (response?.data?.status === 200) {
          updateState("student_details", response?.data ?? {});
          setIsEditable(false);

          toast.success(
            response?.data?.message ||
              "Student profile has been updated successfully.",
            {
              position: "top-center",
            },
          );
        } else {
          setIsEditable(false);
          toast.error(response?.data?.message || "Something went wrong!", {
            position: "top-center",
          });
        }
      } catch (error) {
        setIsEditable(false);
        toast.error(
          error?.response?.data?.message ||
            error?.response?.data?.error ||
            "Something went wrong!",
          {
            position: "top-center",
          },
        );
      }
    }
  };

  const [hasSelectedPlace, setHasSelectedPlace] = useState(
    globalState.teacher_details?.data?.location ? true : false,
  );

  const handlePlaceSelect = (place) => {
    if (place && place.formatted_address) {
      setFormState((prev) => ({
        ...prev,
        location: place.formatted_address,
      }));
      setFormErrors({ location: "" });
      setHasSelectedPlace(true);
    } else {
      setFormErrors({ location: "• Please enter a valid location" });
    }
  };

  const handleAutocompleteInputChange = (event) => {
    const value = event.target.value;

    // Check if the value contains spaces
    if (value.trim() === "") {
      setFormErrors({ location: "• This field is required" });
      setHasSelectedPlace(false);
    } else {
      setFormState((prev) => ({
        ...prev,
        location: value,
      }));

      // Check if the location is empty or if a place has not been selected
      if (!hasSelectedPlace) {
        setFormErrors({ location: "• Please enter a valid location" });
      } else {
        setFormErrors({ location: "" });
      }
    }
  };

  const handleInputBlur = () => {
    if (!hasSelectedPlace && formState.location) {
      setFormState((prev) => ({
        ...prev,
        location: "",
      }));
      setFormErrors({ location: "• Please enter a valid location" });
    }
  };

  const addLanguage = (selectedLanguage) => {
    let error = "";
    error = isRequired(selectedLanguage);
    if (!error) {
      setFormErrors({
        ...formErrors,
        language: "", // Clear the error when a valid language is added
      });
    }
    // add  language to formState.language string separated by comma
    setFormState((prev) => ({
      ...prev,
      language_ids: prev.language_ids
        ? prev.language_ids + "," + selectedLanguage
        : selectedLanguage,
    }));
  };
  const removeLanguage = (selectedLanguage) => {
    let error = isRequired(selectedLanguage);
    setFormErrors({
      ...formErrors,
      language_ids: error,
    });

    // Remove the selected language from formState.language string separated by a comma
    setFormState((prev) => {
      const updatedLanguageIds = prev.language_ids
        ?.split(",")
        ?.filter((item) => item !== selectedLanguage)
        .join(",");
      return {
        ...prev,
        language_ids: updatedLanguageIds,
      };
    });
  };

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isAddToSubjetModelOpen, setIsAddToSubjetModelOpen] = useState(false);
  const [src, setSrc] = useState(null);
  const handleFileInput = async (event) => {
    const errorKey = isTeacher ? "ai_avatar" : "student_profile_pic";
    const file = event.target.files[0];

    if (!file) {
      setSrc(null);
      return;
    }

    if (file.size > 31457280) {
      // Handle the case where the file size is too large
      toast.error("The file size exceeds the maximum limit of 1 MB");
      setFormErrors({
        ...formErrors,
        [errorKey]: "The file size exceeds the maximum limit of 1 MB",
      });
      setSrc(null);
      return; // Exit the function
    }

    const compressedImage = await compressImage(file);
    setSrc(URL.createObjectURL(compressedImage));
    onOpenModal();

    let error = "";
    error = isRequired(file);
    setFormErrors({
      ...formErrors,
      [errorKey]: error,
    });
    event.target.value = null;
  };

  const onOpenModal = () => {
    setModalIsOpen(true);
  };

  const onCloseModal = () => {
    setModalIsOpen(false);
  };

  const handleSaveForm = (event) => {
    event.preventDefault();

    // Validate the LinkedIn URL
    if (isTeacher) {
      const linkedinError = isValidLinkedinUrl(formState.linkedin_url);
      if (linkedinError) {
        setFormErrors({
          ...formErrors,
          linkedin_url: linkedinError,
        });
        return; // Prevent saving if LinkedIn URL is invalid
      }
    }

    // Check if language is empty
    if (isTeacher) {
      if (!formState.language_ids || formState.language_ids.trim() === "") {
        setFormErrors({
          ...formErrors,
          language: "• Language is required.",
        });
        return; // Prevent saving if language is empty
      }
    }

    handleForm4Submit();
  };

  useEffect(() => {
    api
      .get("/auth/get-teacher/", {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Token ${token}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          if (response?.data) {
            updateState("teacher_details", response?.data ?? {});
            if(response?.data?.currency_symbol) {
            updateState("currency_symbol",response?.data?.currency_symbol)
            }

          }
        }
      })
      .catch((error) => {});
  }, [token]);

  useEffect(() => {
    if (!isTeacher) {
      api
        .get("/courses/get-grade-list/", {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Token ${token}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            setGradedetails(response.data.grade);
          }
        })
        .catch((error) => {});
    }
  }, [token]);
  const lastGradeUpdate = new Date(
    globalState?.student_details?.data?.grade_last_update,
  );
  const currentDate = new Date();

  // Calculate the difference in time
  const timeDiff = currentDate.getTime() - lastGradeUpdate.getTime();

  // Convert time difference to days
  const daysDiff = timeDiff / (1000 * 3600 * 24);

  // Determine if the select should be read-only
  const isReadOnly = daysDiff < 14;
  const googleToken = useSelector((state) => state.submitGoogleToken);
  const googleAccessToken = useSelector((state) => state.getGoogleAccessToken);
  const unLinkgdrive = useSelector((state) => state.unlinkgdrive);
  const linkGDriveState = useSelector((state) => state.linkgdrive);

  const onSuccess = async (tokenResponse) => {
    const response = await fetch("https://oauth2.googleapis.com/token", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        code: tokenResponse.code,
        client_id: process.env.REACT_APP_GOOGLEDRIVE_CLIENTID,
        client_secret: process.env.REACT_APP_GOOGLEDRIVE_SECRET_KEY,
        redirect_uri: process.env.REACT_APP_SHARE_URL.replace(/\/$/, ""),
        // redirect_uri: process.env.REACT_APP_SHARE_URL,
        // Ensure this matches with your console setup
        grant_type: "authorization_code",
        access_type: "offline",
      }),
    });

    const tokenData = await response.json();

    if (tokenData) {
      const creds = {
        google_token: {
          token: tokenData.access_token,
          refresh_token: tokenData.refresh_token || null,
          token_uri: "https://oauth2.googleapis.com/token",
          client_id: process.env.REACT_APP_GOOGLEDRIVE_CLIENTID,
          client_secret: process.env.REACT_APP_GOOGLEDRIVE_SECRET_KEY,
          scopes: tokenResponse.scope ? tokenData.scope.split(" ") : [],
          expiry: new Date(
            Date.now() + tokenData.expires_in * 1000,
          ).toISOString(),
        },
      };
      handleLogin(creds);
      setTimeout(() => {
        dispatch(linkGDrive(token, null));
      }, 50);
    }
  };

  const onFailure = (error) => {
    console.error("Login failed:", error);
  };

  const handleLogin = (req) => {
    dispatch(submitGoogleToken(req, token));
  };

  const unLinkGDrive = () => {
    dispatch(unlinkGDrive(token));
  };
  const loginWithGoogle = useGoogleLogin({
    onSuccess,
    onError: onFailure, // Changed from onFailure to onError as per the GIS library
    scope: [
      "https://www.googleapis.com/auth/drive.file",
      "https://www.googleapis.com/auth/drive",
      "https://www.googleapis.com/auth/drive.metadata.readonly",
      "https://www.googleapis.com/auth/drive.metadata",
    ].join(" "),
    access_type: "offline",
    approval_prompt: "force",
    prompt: "consent",
    flow: "auth-code",
  });

  useEffect(() => {
    if (linkGDriveState.message !== null) {
      toast.success("Drive linked Successfully");

      dispatch(resetlinkGoogleDrive());
    }

    if (googleToken?.google_token !== null || unLinkgdrive.message !== null) {
      dispatch(getGoogleTokenAction(token));
    }
    if (unLinkgdrive.message !== null) {
      toast.success("Drive Unlinked Successfully");
    }
    return () => {
      dispatch(resetsubmitgoogleToken());
      dispatch(resetunlinkGoogleDrive());
      // dispatch(resetlinkGoogleDrive())
    };
  }, [googleToken, unLinkgdrive, linkGDriveState]);

  const onEdit = () => {
    console.log("edit");
  };

  return (
    <div className="account_setting_tab_sec">
      <div className="account_setting_tab_sec_head">
        <h6>Account Settings</h6>
        {isEditable ? (
          <button
            className="save_btn_set"
            onClick={handleSaveForm}
            disabled={
              !!formErrors.introduction ||
              !!formErrors.name ||
              !!formErrors.location
            }
          >
            Save
          </button>
        ) : (
          <div className="flex gap-2">
            {isTeacher && 
            <UploadFileBtn handleClick={() => {
                setUploadFileModal(true);
              }}/>
            }
            <PrimaryBtn
              py="py-[9px]"
              icon={<i class="fa-solid fa-pen" />}
              label="Edit"
              handleClick={() => setIsEditable(true)}
            />
          </div>
        )}
      </div>
      <div
        style={{
          pointerEvents: isEditable ? "auto" : "none",
        }}
      >
        <div className="about_teach_sec_new">
          <div className="about_teach_sec_new_left">
            <div className="Personalize-your-AI-Assistant-uplode-image">
              <img src={selectedImage ?? ai_avatar ?? upload_image} alt="" />
              <div
                className="profile_plus_icon"
                onChange={() => {}}
                style={{ cursor: "pointer" }}
              >
                {isEditable && (
                  <span>
                    <i class="fa-solid fa-plus"></i>
                  </span>
                )}
              </div>
              <input
                type="file"
                id="choos-profile-image"
                name="student_profile_pic"
                accept="image/png, image/jpeg"
                style={{
                  height: 106,
                  width: 106,
                }}
                onChange={handleFileInput}
              />
            </div>
            <h5 style={{ textAlign: "center" }}>{formState.name}</h5>
          </div>
          <div className="about_teach_sec_new_right">
            <h4> {isTeacher ? "About Teacher" : "About Student"}</h4>
            <textarea
              name="introduction"
              style={
                formErrors.introduction ? { border: "1px solid red" } : null
              }
              value={formState.introduction || ""}
              onChange={handleInputChange}
              className="introduce-yourself-text"
              maxlength="1000"
              type="text"
              cols="20"
              rows="5"
              placeholder={`For Example:\n• Tell us about yourself.\n• What subjects do you teach?\n• What grades do you teach?\n• Do you teach at a school? If so, which one?`}
              inputprops={{
                style: { color: "red" },
              }}
            ></textarea>
            <p className="errorState">{formErrors.introduction}</p>
          </div>
        </div>
        {isTeacher && (
          <>
            <div
              className="profile_linkedin"
              style={{
                pointerEvents: "auto",
              }}
            >
              <div className="profile_linkedin_image">
                <img src={devicon_linkedin} />
              </div>
              {isEditable ? (
                <input
                  type="text"
                  placeholder="linkedin"
                  name="linkedin_url"
                  value={formState.linkedin_url || ""}
                  onChange={handleInputChange}
                />
              ) : (
                <a href={formState.linkedin_url} target="_blank">
                  {formState?.linkedin_url ?? "-"}
                </a>
              )}
            </div>

            <p className="form-error" style={{ marginTop: "8px" }}>
              {formErrors.linkedin_url}
            </p>
          </>
        )}
        <div className="subject_special">
          <Grid container xs={12} justifyContent={"space-between"}>
            <h5>{isTeacher ? "Subjects" : "Interest"}</h5>
            {isEditable && (
              <button
                className="edit_btn_set"
                onClick={() => setIsAddToSubjetModelOpen(true)}
              >
                {isTeacher ? "Add Subject" : "Add Interest"}
              </button>
            )}
          </Grid>
          <ul className="sub_special">
            {isTeacher
              ? formState.subject_names &&
                formState.subject_names?.map((subject) => (
                  <li key={subject}>{subject}</li> // Use the subject as key if it's unique
                ))
              : formState.interest_names &&
                formState.interest_names?.map((subject) => (
                  <li key={subject}>{subject}</li> // Use the subject as key if it's unique
                ))}
          </ul>
        </div>
        <div
          className="form_sec_settings"
          style={{
            pointerEvents: isEditable ? "auto" : "none",
          }}
        >
          <div
            className="dashboard-popup-teacher-profile-details-form"
            style={{
              backgroundColor: "transparent",
              width: "60%",
              padding: "0px",
            }}
          >
            <div className="dashboard-popup-teacher-profile-details-form-container">
              <div className="dashboard-popup-teacher-profile-details-input">
                <label>Name</label>
                <input
                  id="teacher-create-profile-input"
                  type="name"
                  name="name"
                  style={formErrors.name ? { border: "1px solid red" } : null}
                  value={formState.name || ""}
                  placeholder="Full name"
                  onChange={handleInputChange}
                />
                <div className="teacher-create-popup-gender-input-folder">
                  <div className="form-icon">
                    <img src={profile_image} alt="" />
                  </div>
                  <div className="setect-genter-list-dropdown">
                    {isTeacher && (
                      <select
                        name="title"
                        className="teacher-create-popup-gender-input"
                        style={
                          formErrors.title ? { border: "1px solid red" } : null
                        }
                        value={formState.title || ""}
                        onChange={handleInputChange}
                      >
                        {titles.map((title) => {
                          return (
                            <option key={title.value} value={title.value}>
                              {title.name}
                            </option>
                          );
                        })}
                      </select>
                    )}
                  </div>
                </div>
                <p>{formErrors.name}</p>
              </div>
              {!isTeacher && (
                <div className="dashboard-popup-teacher-profile-details-input">
                  <label>Grade</label>
                  <select
                    name="grade"
                    style={
                      formErrors.grade
                        ? {
                            border: "1px solid red",
                            borderRadius: 6,
                          }
                        : {
                            border: "1px solid #BDBDBD",
                            borderRadius: 6,
                          }
                    }
                    value={formState.grade || ""}
                    onChange={handleInputChange}
                    readOnly={isReadOnly}
                    disabled={isReadOnly}
                  >
                    <option value="">Select Grade</option>
                    {Object.keys(gradedetails).map((key) => (
                      <option key={`gradedetails${key}`} value={key}>
                        {gradedetails[key]}
                      </option>
                    ))}
                  </select>
                  <div className="form-icon grade_icon">
                    <img src={grade_image} alt="" />
                  </div>
                  <p>{formErrors.grade}</p>
                </div>
              )}
              <div className="dashboard-popup-teacher-profile-details-input">
                <label>Email</label>
                <input
                  type="text"
                  placeholder="email id"
                  name="email"
                  readOnly
                  style={formErrors.email ? { border: "1px solid red" } : null}
                  value={formState.email || ""}
                  onChange={handleInputChange}
                />
                <div className="form-icon">
                  <img src={email_image} alt="" />
                </div>
                <p>{formErrors.email}</p>
              </div>
              <div className="dashboard-popup-teacher-profile-details-input">
                <label>Birth Date</label>
                {isEditable ? (
                  <Datetime
                    name="dob"
                    className={formErrors.dob ? "datetime-error" : "datetime"}
                    timeFormat={false}
                    inputProps={{
                      placeholder: "MM/DD/YYYY",
                      value: dobInputValue,
                      onChange: handleDobInput,
                      onBlur: () => {
                        if (dobInputValue.length > 0 && dobInputValue.length < 10) {
                          setFormErrors((prev) => ({ ...prev, dob: "Please enter complete date (MM/DD/YYYY)" }));
                        }
                      },
                      maxLength: 10,
                      style: formErrors.dob ? { border: "1px solid red" } : null,
                    }}
                    value={dobInputValue}
                    closeOnSelect={true}
                    onChange={(date) => {
                      if (typeof date === "object" && date?.isValid && date.isValid()) {
                        const selectedDate = date.toDate();
                        const today = new Date();
                        const minDate = new Date();
                        minDate.setFullYear(today.getFullYear() - (isTeacher ? 21 : 4));
                        if (selectedDate > today) {
                          setFormErrors((prev) => ({ ...prev, dob: "Date of birth cannot be in the future" }));
                          return;
                        }
                        if (selectedDate > minDate) {
                          setFormErrors((prev) => ({ ...prev, dob: isTeacher ? "Teacher must be at least 21 years old" : "Student must be at least 4 years old" }));
                          return;
                        }
                        setDobInputValue(date.format("MM/DD/YYYY"));
                        setFormState((prev) => ({ ...prev, dob: date.format("YYYY-MM-DD") }));
                        setFormErrors((prev) => ({ ...prev, dob: "" }));
                      }
                    }}
                    dateFormat="MM/DD/YYYY"
                    isValidDate={isTeacher ? isValidDateTeacher : isValidDateStudent}
                  />
                ) : (
                  <p className="w-full px-[10px] py-2 pl-[38px] text-[12px] border border-[#bdbdbd] rounded-[6px] !bg-transparent !text-black">{formState.dob ? getFormattedDate(formState.dob) : "—"}</p>
                )}
                <div className="form-icon"><img src={calender_image} alt="" /></div>
                <p>{formErrors.dob}</p>
              </div>
              <div className="dashboard-popup-teacher-profile-details-input">
                <label>Gender</label>
                <div className="dashboard-popup-teacher-profile-gender-folder">
                  <select
                    name="gender"
                    style={
                      formErrors.gender ? { border: "1px solid red" } : null
                    }
                    value={
                      Number.isInteger(parseInt(formState.gender))
                        ? formState.gender
                        : getKeyByValue(
                            ["Choose Other", "Male", "Female", "Other"],
                            formState.gender,
                          ) || ""
                    }
                    onChange={handleInputChange}
                  >
                    {genders.map((gender) => {
                      return (
                        <option key={gender.value} value={gender.value}>
                          {gender.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="form-icon">
                  <img src={gender_image} alt="" />
                </div>
                <p>{formErrors.gender}</p>
              </div>
              {!isTeacher && (
                <div className="dashboard-popup-teacher-profile-details-input">
                  <label>Language</label>
                  <div className="dashboard-popup-teacher-profile-gender-folder">
                    <select
                      name="language"
                      style={
                        formErrors.language
                          ? {
                              border: "1px solid red",
                              borderRadius: 6,
                            }
                          : {
                              border: "1px solid #BDBDBD",
                              borderRadius: 6,
                            }
                      }
                      value={formState.language || ""}
                      onChange={handleInputChange}
                    >
                      <option value="">Select Language</option>
                      {Object.keys(AddtoLanguages)
                        .map((key) => key)
                        .map((key) => (
                          <option key={key} value={AddtoLanguages[key]}>
                            {AddtoLanguages[key]}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="form-icon">
                    <img src={language_image} alt="" />
                  </div>
                  <p>{formErrors.language}</p>{" "}
                </div>
              )}
              <div className="dashboard-popup-teacher-profile-details-input">
                <label>Location</label>
                <Autocomplete
                  apiKey={GOOGLE_MAP_KEY}
                  onPlaceSelected={handlePlaceSelect}
                  defaultValue={formState.location}
                  onChange={handleAutocompleteInputChange}
                  onBlur={handleInputBlur}
                  options={{
                    types: ["(cities)"],
                  }}
                />
                <div className="form-icon location-icon">
                  <img src={location_image} alt="" />
                </div>
                <p>{formErrors.location}</p>
              </div>
            </div>
            {isTeacher && (
              <div className="dashboard-popup-teacher-profile-details-input location-input">
                <label>
                  Language {isEditable && <span>(Select Language)</span>}
                </label>
                <div className="dashboard-popup-teacher-profile-select-Language-container">
                  {isEditable && (
                    <div className="Subjects-you-teach-suggestions-folder">
                      {Object.keys(globalState?.datalist?.languages)
                        .filter((key) => {
                          const languageName =
                            globalState.datalist.languages[key];
                          const languageId = parseInt(key);
                          return (
                            !formState.language_ids.includes(languageName) &&
                            !formState.language_ids.includes(languageId)
                          );
                        })
                        .map((key) => (
                          <a
                            // href="#"
                            key={key}
                            onClick={() => addLanguage(key)}
                          >
                            {globalState?.datalist?.languages[key]}
                          </a>
                        ))}
                    </div>
                  )}
                  {globalState?.datalist?.languages &&
                    (formState.language_ids ?? "")
                      .split(",")
                      .filter((language) => language !== "").length > 0 && (
                      <div className="dashboard-popup-teacher-profile-selected-Language-folder">
                        <div className="Subjects-you-teach-feilds-folder">
                          {formState.language_ids
                            .split(",")
                            .filter((language) => language !== "")
                            .map((language) => {
                              const languageKey = String(language); // Ensure language is a string
                              return (
                                <div
                                  className="Subjects-you-teach-feilds"
                                  key={languageKey}
                                >
                                  <p>
                                    {globalState?.datalist?.languages[
                                      languageKey
                                    ] ??
                                      globalState?.datalist?.languages[
                                        getKeyByValue(
                                          globalState?.datalist?.languages,
                                          languageKey,
                                        )
                                      ]}
                                  </p>
                                  {isEditable && (
                                    <a
                                      className="subject-delete-btn"
                                      onClick={() =>
                                        removeLanguage(languageKey)
                                      }
                                    >
                                      <i className="fa-solid fa-xmark"></i>
                                    </a>
                                  )}
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    )}
                </div>
                <p>{formErrors.language}</p>
              </div>
            )}
          </div>
        </div>
      </div>
      {modalIsOpen && (
        <CropProfileImageModal
          src={src}
          setSrc={setSrc}
          setSelectedImage={setSelectedImage}
          setImageUploaded={setImageUploaded}
          setUplodedImage={setUplodedImage}
          modalStatus={modalIsOpen}
          setModalClose={onCloseModal}
          fieldName={isTeacher ? "ai_avatar" : "student_profile_pic"}
          setFormState={setFormState}
          formState={formState}
        />
      )}
      {isAddToSubjetModelOpen && (
        <EditSubject
          subject_title="Subjects you are interested in"
          modalStatus={isAddToSubjetModelOpen}
          subjectlist={Object.values(
            isTeacher
              ? Object.values(
                  globalState.teacher_details?.data?.subjects || {},
                ) || {}
              : Object.values(
                  globalState.student_details?.data?.interest || {},
                ) || {},
          )}
          setModalClose={() => setIsAddToSubjetModelOpen(false)}
          onClose={() => setIsAddToSubjetModelOpen(false)}
          onSubmit={(subjects) => {
            setFormState((prev) => ({
              ...prev,
              [subjectsKey]: subjects,
            }));
            setIsAddToSubjetModelOpen(false);
          }}
        />
      )}
      {isTeacher && (
        <ProfileModal
          open={uploadFileModal}
          close={() => setUploadFileModal(false)}
        />
      )}
    </div>
  );
}

export default Profile;